var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOutlink = function SvgIconOutlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.125a.966.966 0 0 1 0 1.932H3.39v11.552h11.553V12.5c0-.498.377-.908.86-.96l.106-.006c.534 0 .966.433.966.966v5.076a.966.966 0 0 1-.966.966H2.424a.967.967 0 0 1-.966-.966V4.09c0-.534.433-.966.966-.966zm10.076-1.667c.533 0 .966.433.966.966v6.06a.967.967 0 0 1-1.932.001v-3.73l-7.442 7.443a.964.964 0 0 1-.575.277l-.108.006a.966.966 0 0 1-.683-1.649l7.441-7.442h-3.728a.966.966 0 0 1-.96-.86l-.006-.106c0-.533.433-.966.966-.966z",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};
export default SvgIconOutlink;